import React, { Component } from 'react';

import { Tag } from '@blueprintjs/core'

import U from '../Utilities/Utilities'

class All extends Component {
    render() {
        return this.props.keywords ? (
            <div>
                { Object.keys(this.props.keywords).map((group) => (
                    <>
                        <strong style={{
                            display: 'block',
                            color: U.keywordColor(group),
                            marginBottom: 5
                        }}>{group}</strong>
                        <div>
                        { this.props.keywords[group].filter((k) => (k && k.length>0)).map((k) => (
                            <Tag
                                key={k}
                                minimal
                                interactive
                                round
                                style={{
                                    background: 'transparent',
                                    padding: 5
                                }}
                            >{k}</Tag>
                        ))}
                        </div>
                    </>
                )) }
            </div>
        ) : null;
    }
}

export default All;